<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      // 设备
      client: this.MixinClientBrowser(),
      // token
      token: this.$store.state.token,
      // uuid
      cookieId: this.$store.state.cookieId,
    }
  },
  watch: {
    $route() {
      document.title = this.$route.meta.title
      document.getElementById('app').scroll(0, 0)
    },
  },
}
</script>
<style>
table {
  width: 100%;
  border-collapse: collapse !important;
  font-size: 12px !important;
  color: #666666 !important;
  /*表格的边框合并为一个单一的边框*/
  margin-bottom: 0.5rem;
}
table,
table tr th,
table tr td {
  border: 1px solid #ccc !important;
}
td,
th,
tr {
  padding: 0.2rem;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
